export const getSpotlightLocalStorageKey = (page: string): string => {
  return `spotlight-tour-${page}`;
};

export const setSpotlightLocalStorage = (page: string, value: string): void => {
  localStorage.setItem(getSpotlightLocalStorageKey(page), value);
};
